import { updatePostDetail } from ".";
import { updateCommentReaction } from "../sections.store/sections-realtime-reducer";

export function postDetailHandleLikeIncrement(socketPayload) {
  return async (dispatch, getState) => {
    const { postDetail, auth } = getState();
    const newPost = { ...postDetail.post };
    const { user, increment, postId, sectionId, groupId } = socketPayload;
    if (newPost && newPost.id === postId && auth.id !== user.id) {
      newPost.likes += increment;
      newPost.likeCount += increment;
      dispatch(updatePostDetail(newPost));
    }
  };
}

export function postDetailHandleAddComment(socketPayload) {
  return async (dispatch, getState) => {
    const { postDetail, auth } = getState();
    const newPost = { ...postDetail.post };
    const { postId, sectionId, groupId, postCommentId, comment } =
      socketPayload;
    const { createdBy: user } = comment;
    if (newPost && newPost.id === postId && auth.id !== user.id) {
      // update latest comment
      newPost.latestComment = comment;

      // update all comments if required
      if (Array.isArray(newPost.comments)) {
        newPost.comments.unshift(comment);
      }
      dispatch(updatePostDetail(newPost));
    }
  };
}

export function postDetailHandleRemoveComment(socketPayload) {
  return async (dispatch, getState) => {
    const { postDetail, auth } = getState();
    const newPost = { ...postDetail.post };
    const { postId, sectionId, groupId, postCommentId } = socketPayload;
    if (newPost && newPost.id === postId) {
      // update latest comment, if needed
      if (newPost.latestComment?.id === postCommentId) {
        newPost.latestComment = null;
      }

      // find if we have comment
      const comment = newPost.comments?.find((c) => c.id === postCommentId);
      if (comment) {
        // we have comment, remove it
        newPost.commentCount = newPost.commentCount - 1;
        newPost.comments = newPost.comments.filter(
          (c) => c.id !== postCommentId
        );
      }
      dispatch(updatePostDetail(newPost));
    }
  };
}

export function postDetailHandleCommentReactionUpdateFromSocket(socketPayload) {
  return async (dispatch, getState) => {
    const { postDetail, auth } = getState();
    const newPost = { ...postDetail.post };
    const { postId, sectionId, groupId, postCommentId, reaction, user } =
      socketPayload;
    if (newPost && newPost.id === postId && auth.id !== user.id) {
      // update latest comment, if needed
      if (newPost.latestComment?.id === postCommentId) {
        // yes same comment
        newPost.latestComment = updateCommentReaction(
          newPost.latestComment,
          reaction,
          user
        );
      }

      // find if we have comment
      const commentIndex = newPost.comments?.findIndex(
        (c) => c.id === postCommentId
      );
      if (commentIndex > -1) {
        newPost.comments[commentIndex] = updateCommentReaction(
          newPost.comments[commentIndex],
          reaction,
          user
        );
      }
      dispatch(updatePostDetail(newPost));
    }
  };
}
